import * as React from 'react'
import { cn } from '../../lib/utils'
import { cva, type VariantProps } from 'class-variance-authority'

export const inputContainerVariants = cva(
  'font-regular placeholder:text-neutral-surface-50 flex w-full min-w-0 transition-colors duration-200 outline-none file:inline-flex data-[disabled=true]:pointer-events-none data-[disabled=true]:cursor-not-allowed data-[disabled=true]:opacity-50 data-[error=true]:border-negative-surface-100 data-[error=true]:bg-negative-surface-5 data-[error=true]:ring-negative-surface-20 data-[error=true]:ring-[2px]',
  {
    variants: {
      inputSize: {
        sm: 'text-sm [&_svg]:size-icon-sm p-[0.375rem]',
        md: 'text-md [&_svg]:size-icon-md p-[0.5rem]',
        lg: 'text-lg [&_svg]:size-icon-md  p-[0.626rem]',
      },
      variant: {
        fill: 'bg-neutral-surface-dark hover:bg-neutral-surface border-neutral-surface-dark rounded-sm border data-[focused=true]:border-base-main data-[state=open]:border-base-main data-[focused=true]:bg-neutral-surface-light data-[state=open]:bg-neutral-surface-light data-[focused=true]:ring-neutral-surface-20 data-[state=open]:ring-neutral-surface-20 data-[focused=true]:ring-[2px] data-[state=open]:ring-[2px]',
        line: 'border-neutral-surface-20 hover:border-neutral-surface-40 rounded-sm border data-[focused=true]:border-base-main data-[state=open]:border-base-main data-[focused=true]:bg-neutral-surface-light data-[state=open]:bg-neutral-surface-light data-[focused=true]:ring-neutral-surface-20 data-[state=open]:ring-neutral-surface-20 data-[focused=true]:ring-[2px] data-[state=open]:ring-[2px]',
      },
    },
    defaultVariants: {
      inputSize: 'md',
      variant: 'fill',
    },
  },
)

export interface InputContainerProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof inputContainerVariants> {
  'data-error'?: boolean
  'data-focused'?: boolean
  'data-read-only'?: boolean
  'data-disabled'?: boolean
}

export const InputContainer = React.forwardRef<
  HTMLDivElement,
  InputContainerProps
>(
  (
    {
      inputSize,
      variant,
      'data-error': dataError,
      'data-focused': dataFocused,
      'data-read-only': dataReadOnly,
      'data-disabled': dataDisabled,
      className,
      children,
    },
    ref,
  ) => {
    return (
      <div
        ref={ref}
        data-error={dataError}
        data-focused={dataFocused && !dataError}
        data-read-only={dataReadOnly}
        data-disabled={dataDisabled}
        className={cn(
          inputContainerVariants({
            inputSize,
            variant,
          }),
          className,
        )}
      >
        {children}
      </div>
    )
  },
)

InputContainer.displayName = 'InputContainer'
